export const EXCMCAR_DELETE_RESET = 'EXCMCAR_DELETE_RESET'
export const EXCMCAR_DELETE_SET_ERROR = 'EXCMCAR_DELETE_SET_ERROR'
export const EXCMCAR_DELETE_SET_DELETED = 'EXCMCAR_DELETE_SET_DELETED'
export const EXCMCAR_DELETE_TOGGLE_LOADING = 'EXCMCAR_DELETE_TOGGLE_LOADING'
